export default "__VITE_ASSET__cb34eecc__"